import React, { ReactElement } from 'react'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import HeaderFont from '../../HelperClass/HeaderFont'
import HeaderTemplate from '../../HelperClass/Template/Header'
import StatisticsRowItem from '../../HelperClass/RowItem/StatisticsRowItem'

export type Props = {
    /**
     * Is there a more button
     */
    hasMore?: boolean
} & TestID

const MotorSportHeader = ({ hasMore, testID }: Props): ReactElement => {
    return (
        <HeaderTemplate competitorLabel="Name" hasMore={hasMore} testID={testID}>
            <StatisticsRowItem width={64}>
                <HeaderFont align="center">Pkt.</HeaderFont>
            </StatisticsRowItem>
        </HeaderTemplate>
    )
}

export default MotorSportHeader
